export default __webpack_public_path__ + "static/media/promo_03.b92ff187.jpg";